import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Toolbar from './components/Toolbar';
import Sidebar from './components/Sidebar';
import VideoGeneration from './components/VideoGeneration';
import VideoGenerationBatch from './components/VideoGenerationBatch';
import VideoLabeling from './components/VideoLabeling';
import AssetManagement from './components/AssetManagement';
import Home from './components/Home';
import Settings from './components/Settings';
import Login from './components/Login';

const PrivateRoute = ({ children }) => {
  const isAuthEnabled = process.env.REACT_APP_AUTH_ENABLED === 'true';

  if (!isAuthEnabled) {
    return children;
  }

  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const MainLayout = ({ children }) => {
  const [selectedMenu, setSelectedMenu] = React.useState('Home');
  return (
    <div className="min-h-screen bg-gray-900 p-8">
      <div className="flex dark:bg-gray-800 rounded-lg shadow-orange-glow overflow-hidden min-h-[90vh]">
        <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
        <div className="flex-1 flex flex-col bg-white">
          <Toolbar />
          <div className="flex-1 overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout>
                <Home />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/studio"
          element={
            <PrivateRoute>
              <MainLayout>
                <VideoGeneration />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/studio-batch"
          element={
            <PrivateRoute>
              <MainLayout>
                <VideoGenerationBatch />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/labeling"
          element={
            <PrivateRoute>
              <MainLayout>
                <VideoLabeling />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/assets"
          element={
            <PrivateRoute>
              <MainLayout>
                <AssetManagement />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <MainLayout>
                <Settings />
              </MainLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;